import Insured from '@/modules/common/common/models/APP/Insured'
import { RaterAnswers } from '@/modules/common/rater/models/APP/RaterAnswers'
import LifeReevaluationOption from '@/modules/life/common/models/APP/LifeReevaluationOption'

export default class LifeRaterAnswers extends RaterAnswers {
  insuranceType: string | null
  coveragesCapital: number
  reevaluationType: LifeReevaluationOption | null

  constructor(data: any = {}) {
    super(data)

    this.forWhom = data.forWhom
    this.forWhomPeople = 1
    this.insuranceType = data.insuranceType ?? null
    this.insureds = [new Insured()]
    this.coveragesCapital = data.coveragesCapital ?? 0
    this.reevaluationType = data.reevaluationType
      ? new LifeReevaluationOption(data.reevaluationType)
      : null
  }
}
